export default "__VITE_ASSET__CjVKnbuo__"